import PropTypes from "prop-types";
import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";

/**
 * Generic confirmation dialog (e.g. “Are you sure?”).
 * Pass `message` for simple text, or `children` for custom body content.
 */
const ConfirmModal = ({
  isOpen,
  toggle,
  title = "Are you sure?",
  message,
  children,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "primary",
  onConfirm,
  isLoading = false,
  confirmDisabled = false
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered backdrop="static" size="md">
      <ModalHeader toggle={!isLoading ? toggle : undefined}>{title}</ModalHeader>
      <ModalBody>
        {children ?? <div className="text-muted">{message}</div>}
      </ModalBody>
      <ModalFooter className="border-top">
        <Button color="secondary" outline type="button" onClick={toggle} disabled={isLoading}>
          {cancelLabel}
        </Button>
        <Button
          color={confirmColor}
          type="button"
          onClick={onConfirm}
          disabled={isLoading || confirmDisabled}
          className="fw-semibold"
        >
          {isLoading ? (
            <>
              <Spinner size="sm" className="me-2" /> Please wait…
            </>
          ) : (
            confirmLabel
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.node,
  message: PropTypes.node,
  children: PropTypes.node,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmColor: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  confirmDisabled: PropTypes.bool
};

export default ConfirmModal;
